// src/environment/environment.dev.js
const environment = {
//  API_URL: "http://192.168.1.150:9095/",
API_URL: "https://smartforum.in/api/"
};

export default environment;
